var ContactDetailsFactory = function ($resource, $window) {
    return {
        retrieveContactDetails: $resource(
            __baseApiUrl__ + "/participant-web-services/rest/partialauth/retrieveContactDetails",
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        )
    };
};

ContactDetailsFactory.$inject = ["$resource", "$window"];
export default ContactDetailsFactory;
